import ProtectedRoute from "@/components/ProtectedRoute";
import Settings from "./Settings";

export default function ProtectedSettings() {
  return (
    <ProtectedRoute requiredRole="admin">
      <Settings />
    </ProtectedRoute>
  );
}
